import Vue from 'vue';
import Vuex from 'vuex';

// DevOps
import account from './modules/account';
import tasks from './modules/tasks';
import loading from './modules/loading';
import users from './modules/users';
import pullRequests from './modules/pullRequests';
import bugs from './modules/bugs';
import workItems from './modules/workItems';
import projects from './modules/projects';
// ConnectWise
import members from './modules/members';
import availability from './modules/availability';
import opportunities from './modules/opportunities';
import activities from './modules/activities';

import apiPlugin from './plugins/api';

Vue.use(Vuex);

const actions = {
  init({ dispatch, rootGetters }) {
    dispatch('account/init');

    if (rootGetters['account/isLoggedIn']) {
      dispatch('users/getList');
    }
    dispatch('members/getList');
  },
};

const store = new Vuex.Store({
  plugins: [apiPlugin],
  actions,
  modules: {
    account,
    activities,
    tasks,
    loading,
    users,
    members,
    availability,
    opportunities,
    pullRequests,
    bugs,
    workItems,
    projects,
  },
});

export default store;
